export default function Canvas_Images() {
  return (
    <div>
      <h1>Canvas_Images Component</h1>
    </div>
  );
}
